import Vue from 'vue';

import Ranking from '@/views/Ranking.vue';
import HomePage from '@/views/HomePage.vue';
import Courses from '@/views/CoursesDetail.vue';
import Coaches from '@/views/Coaches.vue';
import Finder from '@/views/Finder.vue';
import Community from '@/views/Community.vue';
import CommunityDetail from '@/views/CommunityDetail.vue';
import StepRegist from '@/views/StepRegist.vue';
import Login from '@/views/Login.vue';
import Forgot from '@/views/Forgot.vue';
import ResetPass from '@/views/ResetPass.vue';
import AboutUs from '@/views/AboutUs.vue';
import Profile from '@/views/Profile.vue';
import Profiles from '@/views/Profiles.vue';
import Tabs from '@/components/Courses/Tabs.vue';
import RootMedia from '@/views/RootMedia.vue';
import NotFound from '@/views/NotFound.vue';
import NewsFeed from '@/views/NewsFeed.vue';
import PostDetail from '@/views/PostDetail.vue';
import RGPD from '@/views/RGPD.vue';
import Legal from '@/views/Legal.vue';
import Terms from '@/views/Terms.vue';
import Selling from '@/views/Selling.vue';
import Contact from '@/views/Contact.vue';
import {translate} from 'vue-gettext';
const {gettext: gettextClone} = translate;
let routeLanguage = 'en_EN'
if(location.host.startsWith('fr.')
  || location.host.startsWith('www.fr.')
) {
  routeLanguage = 'fr_FR'
} else if(location.host.startsWith('vn.')
  || location.host.startsWith('www.vn.')
) {
  routeLanguage = 'vi_VN'
} else if(location.host.startsWith('it.')
  || location.host.startsWith('www.it.')
) {
  routeLanguage = 'it_IT'
} else if(location.host.startsWith('de.')
  || location.host.startsWith('www.de.')
) {
  routeLanguage = 'de_DE'
}

let $gettext = function(path) {
  return gettextClone(path, routeLanguage)
}

if(window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.foo) {
  $gettext = Vue.prototype.$gettext;
}

export default () => {
return [
  {
    path: '/',
    alias: ['*index.html'],
    name: 'homepage',
    component: HomePage,
    meta: {
      title: $gettext('Home'),
      guest: true
    },
  },
  {
    path: '/' + $gettext('newsfeed.html'),
    name: 'newsfeed',
    component: NewsFeed,
    meta: {
      title: $gettext('Newsfeed'),
      guest: true
    },
  },
  {
    path: '/' + $gettext('coaches.html'),
    name: 'coaches',
    component: Coaches,
    meta: {
      title: $gettext('Vloggers - Coaches'),
      guest: true
    },
  },
  {
    path: '/' + $gettext('player-finder.html'),
    name: 'player-finder',
    component: Finder,
    meta: {
      title: $gettext('Player Finder'),
      guest: true
    },
  },
  {
    path: '/' + $gettext('community.html'),
    name: 'community',
    component: Community,
    meta: {
      title: $gettext('Community'),
      guest: true
    },
  },
  {
    path: '/community/:id',
    name: 'communityDetail',
    component: CommunityDetail,
    meta: {
      title: 'communityDetail',
      guest: true
    },
  },
  {
    path: '/' + $gettext('register.html'),
    name: 'register',
    component: StepRegist,
    meta: {
      title: $gettext('Register'),
      loggedOut: true
    },
  },
  {
    path: '/' + $gettext('login.html'),
    name: 'login',
    component: Login,
    meta: {
      title: $gettext('Login'),
      loggedOut: true
    },
  },
  {
    path: '/login-token/:email/:token',
    name: 'login-token',
    meta: {
      title: 'Login Token',
      guest: true
    },
  },
  {
    path: '/' + $gettext('forgot-password.html'),
    name: 'forgot',
    component: Forgot,
    meta: {
      title: $gettext('Forgot password'),
      loggedOut: true
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPass,
    meta: {
      title: $gettext('Reset Password'),
      loggedOut: true
    },
  },
  {
    path: '/' + $gettext('about-us.html'),
    name: 'aboutUs',
    component: AboutUs,
    meta: {
      title: $gettext('About Us'),
      guest: true
    },
  },
  {
    path: '/profile',
    name: "profile",
    component: Profile,
    meta: {
      title: $gettext('Profile User'),
    },
  },
  {
    path: '/profiles/:key',
    name: 'profilePerson',
    meta: {
      title: $gettext('Profile Detail'),
      guest: true
    },
    component: Profiles
  },
  {
    path: '/' + $gettext('ranking-top:top-golf-courses-worldwide.html'),
    name: 'ranking-worldwide',
    component: Ranking,
    meta: {
      title: 'Ranking',
      guest: true
    },
  },
  {
    path: '/' + $gettext('top-golf-courses-worldwide.html'),
    name: 'ranking-worldwide-all',
    component: Ranking,
    meta: {
      title: 'Ranking',
      guest: true
    },
  },
  {
    path: '/' + $gettext('top-golf-courses-:country/ranking-top:top-golf-courses-:countryName.html'),
    name: 'ranking-country',
    component: Ranking,
    meta: {
      title: 'Ranking',
      guest: true
    },
  },
  {
    path: '/' + $gettext('top-golf-courses-:country.html'),
    name: 'ranking-country-all',
    component: Ranking,
    meta: {
      title: 'Ranking',
      guest: true
    },
  },
  {
    path: '/' + $gettext(':zone-top-golf-course/ranking-top:top-golf-courses-:zoneName.html'),
    name: 'ranking-zone',
    component: Ranking,
    meta: {
      title: 'Ranking',
      guest: true
    },
  },
  {
    path: '/' + $gettext(':zone-top-golf-courses.html'),
    name: 'ranking-zone-all',
    component: Ranking,
    meta: {
      title: 'Ranking',
      guest: true
    },
  },
  {
    path: '/' + $gettext('top-golf-courses-:coursesCountry'),
    name: 'courses',
    component: Courses,
    meta: {
      title: 'Courses',
      guest: true
    },
    children: [
      {
        path: '/' + $gettext('top-golf-courses-:coursesCountry/:namegolf-golf-course-about.html'),
        name: 'courses.about',
        meta: {
          title: 'About',
          tab: 1,
          guest: true
        },
        component: Tabs
      },
      {
        path: '/' + $gettext('top-golf-courses-:coursesCountry/:namegolf-golf-course-director-interview.html'),
        name: 'courses.directorInterview',
        meta: {
          title: 'Director Interview',
          tab: 2,
          guest: true
        },
        component: Tabs
      },
      {
        path: '/' + $gettext('top-golf-courses-:coursesCountry/:namegolf-golf-course-reviews.html'),
        name: 'courses.reviews',
        meta: {
          title: 'Reviews',
          tab: 3,
          guest: true
        },
        component: Tabs
      },
      {
        path: '/' + $gettext('top-golf-courses-:coursesCountry/:namegolf-golf-course-vlog.html'),
        name: 'courses.vlog',
        meta: {
          title: 'Golf VLOG',
          tab: 4,
          guest: true
        },
        component: Tabs
      },
      {
        path: '/' + $gettext('top-golf-courses-:coursesCountry/:namegolf-golf-course-videos-photos.html'),
        name: 'courses.videosPhotos',
        meta: {
          title: 'Videos Photos',
          tab: 5,
          guest: true
        },
        component: Tabs,
      },
      {
        path: '/' + $gettext('top-golf-courses-:coursesCountry/:namegolf-golf-course-promotions.html'),
        name: 'courses.promotions',
        meta: {
          title: 'Promotions',
          tab: 6,
          guest: true
        },
        component: Tabs
      },
      {
        path: '/' + $gettext('top-golf-courses-:coursesCountry/:namegolf-golf-course.html'),
        name: 'courses.home',
        meta: {
          title: 'Home',
          tab: 0,
          guest: true
        },
        component: Tabs
      },
    ]
  },
  {
    path: '/' + $gettext('posts/:id/:commentId?'),
    name: 'postDetail',
    component: PostDetail,
    meta: {
      title: 'PostDetail',
      guest: true
    },
  },
  {
    path: '/' + $gettext('rgpd.html'),
    name: 'rgpd',
    component: RGPD,
    meta: {
      title: 'RGPD',
      guest: true
    },
  },
  {
    path: '/' + $gettext('legal.html'),
    name: 'legal',
    component: Legal,
    meta: {
      title: 'Legal',
      guest: true
    },
  },
  {
    path: '/' + $gettext('terms.html'),
    name: 'terms',
    component: Terms,
    meta: {
      title: 'Terms',
      guest: true
    },
  },
  {
    path: "/:type/:mediaId/:parentType/:parentId",
    name: 'mediaView',
    component: RootMedia,
    meta: {
      guest: true
    }
  },
  {
    path: '/' + $gettext('service.html'),
    name: 'selling',
    component: Selling,
    meta: {
      title: 'Service',
      guest: true
    },
  },
  {
    path: '/' + $gettext('contact.html'),
    name: 'contact',
    component: Contact,
    meta: {
      title: 'Contact',
      guest: true
    },
  },
  {
    path: "*",
    name: '404',
    component: NotFound,
    meta: {
      guest: true
    }
  },
]
}